import { createHelpers } from 'vuex-map-fields';

const { getMemCountField, updateMemCountField } = createHelpers({
    getterType: `getMemCountField`,
    mutationType: `updateMemCountField`,
});

const state = {
    mem_counts : [],
}

// actions
const actions = {
    LOAD_MENU_COUNTS ({commit}) {
        axios.post('/docs/internal/api/mem_counts').then(({data}) => {
            if(data.status === 'operation_success') {
                commit('mem_counts', data.data);
            }
        }).catch(err => {
            commit('mem_counts', []);
        });
    },
}

const getters = {
    getMemCountField,
}

// mutations
const mutations = {
    updateMemCountField,

    mem_counts (state, data) {
        state.mem_counts = [];
        if(data.length > 0) {
            data.map(menu => {
                state.mem_counts.push(menu);
            })
            EventBus.$emit('mem_count_ready',data);
        }
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
